export default __webpack_public_path__ + "static/media/belgium-flag.4ef2964a.png";